interface Window {
  webkit?: any;
}

declare var window: Window & typeof globalThis;

const isWebview = () => {
  const hasWebkit = window.webkit;
  // eslint-disable-next-line no-undef
  return (
    hasWebkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.cordova_iab
  );
};

export const webviewMessage = (message: any) => {
  // eslint-disable-next-line no-undef
  if (isWebview()) {
    window.webkit.messageHandlers.cordova_iab.postMessage(
      JSON.stringify(message)
    );
  }
};
